<template>
    <div id="main" class="success_container">
        <div>
            <div class="success_png">
                <!-- <img src="@/assets/image/return/Group 49@2x.png"> -->
                <svg width="192" height="192" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z" fill="#1BB84B"/>
                  <path d="M69.4521 151.29L122.552 204.39L229.875 95.8999" stroke="white" stroke-width="30" stroke-linecap="round"/>
                </svg>
            </div>
            <div class="success_value">
                <p>{{$t(title)}}</p>
            </div>
            <div class="success_id" v-if="expressNumber">
              {{$t('success.successID')}}: {{`&nbsp;${expressNumber}`}}
            </div>
            <div class="success_new_id" v-if="newOrderNumber">
              {{$t('success.newOrderNumber')}}: {{`&nbsp;${newOrderNumber}`}}
            </div>
            <div class="success_text" @click="editNote" v-if="showNote">
                <p>{{save_note}}</p>
<!--                <div v-if="!showCurtain" class="scan-note" @click="scanNote">-->
<!--                    <img class="scan-icon" src="../../assets/image/common/scan.png" alt="">-->
<!--                    Scan parcel location-->
<!--                </div>-->
            </div>
            <div style="min-height: calc(70vh);"></div>
            <div class="action-button">
                <button class="details_bt_w" @click="home()">{{$t('common.Home')}}</button>
                <button v-if="next" class="details_bt_b" @click="nextAction()">{{$t('common.ScanNext')}}</button>
            </div>

            <bottom></bottom>
        </div>
        <div class="curtain" v-if="showCurtain"></div>
        <div class="remark_details_edit" v-if="showCurtain">
            <div class="remark_details_input">
                <div class="remark_edit_title">{{$t('success.EditNote')}}</div>
                <div>
                    <textarea v-model="note_text" class="remark_edit_input">{{note_text}}</textarea>
                    <div class="save-cancel-box">
                        <a @click="save" class="remark_edit_a remark_edit_a_blue">{{$t('common.Save')}}</a>
                        <a @click="cancel" class="remark_edit_a remark_edit_a_gray">{{$t('common.Cancel')}}</a>
                    </div>
                    <div class="remark_scan-note" @click="scanNote">
                        <img class="remark_scan-icon" src="../../assets/image/common/scan.png" alt="">
                        <span>{{$t('details.ScanParcel')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bottom from '../Bottom.vue'

export default {
  name: 'EditRemark',
  data () {
    return {
      showNote: false,
      title: null,
      titleDisplay: null,
      action: null,
      showCurtain: false,
      note_text: null,
      save_note: this.$t('success.Note'),
      next: false
    }
  },
  watch: {
    title (val) {
      if (val === 'MerchantStoreSuccess' || val === 'CustomerStoreSuccess') {
        this.showNote = true
      } else {
        this.showNote = false
      }
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  created () {
    let vue = this
    let param = this.$route.query
    this.title = this.$route.query.msg
    this.action = this.$route.query.action
    this.next = this.$route.query.next !== 'undefined' && this.$route.query.next
    this.original_action = this.$route.query.original_action
    let orderId = this.$route.query.orderId
    let expressNumber = this.$route.query.expressNumber
    let newOrderNumber = this.$route.query.newOrderNumber
    vue.orderId = orderId
    vue.expressNumber = expressNumber
    vue.newOrderNumber = newOrderNumber
    let scanNote = this.$route.query.scanNote
    if (scanNote) {
      this.note_text = scanNote
      this.showCurtain = true
      // let orderId = this.$route.query.orderId
      // 扫码及时保存方式
      // vue.axios({
      //   method: 'post',
      //   url: vue.api.updateOrderNote,
      //   timeout: 3000,
      //   data: {
      //     note: scanNote,
      //     ordersId: orderId
      //   }
      // }).then(function (response) {
      //   vue.showCurtain = false
      //   vue.save_note = vue.note_text
      // }).catch(function (err) {
      //   if (err.data.message) {
      //     alert(err.data.message)
      //   }
      // })
    } else {
      if (orderId) {
        this.axios({
          method: 'get',
          url: this.api.orderDetail + orderId
        }).then(function (response) {
          vue.note_text = response.data.note
        }).catch(function (error) {
          alert('Wrong orderId')
          this.$router.back()
        })
      }
    }
  },
  components: {bottom},
  methods: {
    home () {
      this.$router.push('/index')
    },
    nextAction () {
      const queryMap = this.$route.query
      queryMap.action = queryMap.original_action || queryMap.action

      if (queryMap.action === 'collectingPointStoreExpress') {
        this.$router.push('/selectFlow')
        return
      }

      let queryStr = ''
      Object.keys(queryMap).forEach(key => {
        if (key === 'action' || key === 'logisticsId' || key === 'next') {
          queryStr += `&${key}=${queryMap[key]}`
        }
      })
      this.$router.push('/barcode?' + queryStr)
    },
    scanNote (e) {
      e.stopPropagation()
      let orderId = this.$route.query.orderId
      let msg = this.$route.query.msg
      // this.$router.push('/barcode?action=scanNote&orderId=' + orderId + '&msg=' + msg)
      this.$router.push('/barcode?action=scanNote&orderId=' + orderId + '&msg=' + msg + '&original_action=' + this.action + '&next=' + this.next + '&expressNumber=' + this.expressNumber)
    },
    editNote () {
      this.showCurtain = true
      this.note_text = ''
    },
    save () {
      // 修改note
      const vue = this
      vue.action = vue.original_action || vue.action
      const note = this.note_text
      let orderId = this.$route.query.orderId
      vue.axios({
        method: 'post',
        url: vue.api.updateOrderNote,
        timeout: 3000,
        data: {
          note: note,
          ordersId: orderId
        }
      }).then(function (response) {
        vue.showCurtain = false
        vue.save_note = vue.note_text
        // vue.$router.push('/order/details?&order=' + orderId)
      }).catch(function (err) {
        if (err.data.message) {
          alert(err.data.message)
        }
      })
    },
    cancel () {
      this.showCurtain = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .success_png {
        // width: 1.5rem;
        // height: 1.5rem;
        margin: 0 auto;
        margin-top: 11.87%;
        // margin-bottom: 0.5rem;
        margin-bottom: 0.25rem;

        display: flex;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .success_value {
        margin: 0 auto;
        text-align: center;
        min-height: 0.43rem;
        white-space: pre-line;
        font-weight: 900;

        p {
            font-size: 0.3rem;
            color: #000;
            line-height: 0.355rem;
            font-weight: bold;
        }
    }

    .success_id {
      margin-top: 20px;
      display: flex;
      justify-content: left;
      text-decoration: none;
      font-size: 0.15rem;
      width: 3.09rem;
      margin-left: auto;
      margin-right: auto;
    }
    .success_new_id {
      // margin-top: 20px;
      display: flex;
      justify-content: left;
      text-decoration: none;
      font-size: 0.15rem;
      width: 3.09rem;
      margin-left: auto;
      margin-right: auto;
      overflow-wrap: anywhere;
    }

    .success_text {
        margin: 0 auto;
        width: 2.72rem;
        height: 1.23rem;
        background: #FFFFFF;
        border: 1px solid #707070;
        border-radius: 0.1rem;
        margin-top: 0.415rem;
        padding: 0.135rem 0.185rem;
        text-align: left;
        margin-bottom: 3rem;
        white-space: pre-wrap;

        p {
            font-size: 0.15rem;
            font-weight: 900;
            line-height: 0.18rem;
            color: #ACACAC;
        }
    }

    .details_bt_w {
        width: 82%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        margin: 0.805rem 9% 0;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
    }

    .details_bt_b {
        width: 82%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: var(--primary-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        margin: 0.1rem 9% 0;
        border: none;
        // color: #ffffff;
        color: var(--primary-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
    }

    .scan-note {
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color: #5A5A5A;
        top: 4.4rem;
        left: 1rem;
        width: auto;
        height: 0.3rem;
        line-height: 0.3rem;
        background: #fff;
        box-shadow: -0.03rem 0.06rem 0.09rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.13rem;
        font-size: 0.15rem;
        z-index: 5;
    }

    .scan-icon {
        height: 50%;
    }
    .curtain{
        z-index: 2;
        width:100%;
        height: 100%;
        position:fixed;
        top: 0;
        background: #000;
        opacity:0.5;
        left: 0;
    }
    .remark_details_edit {
        z-index: 3;
        width: 3.415rem;
        height: 3.375rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #ffffff;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
    }
    .remark_edit_title {
        color: #1F8DC5;
        line-height: 0.18rem;
        height: 0.18rem;
        font-size: 0.15rem;
        margin-left: 4.5%;
        padding-top: 0.245rem;
        font-weight: 500;
    }
    .remark_edit_input {
        height: 2.025rem;
        border: 1px solid rgba(112, 112, 112, 1);
        border-radius: 0.1rem;
        width: 77.5%;
        margin-left: 4.5%;
        margin-top: 0.165rem;
        font: 400 0.15rem Rubik;
        color: #000;
        line-height: 0.18rem;
        padding: 0.12rem 0.17rem;
        display: inline-block;
    }
    .save-cancel-box{
        display: flex;
        flex-direction: row-reverse;
    }
    .remark_edit_a {
        height: 0.18rem;
        font-size: 0.15rem;
        margin-top: 0.1rem;
        display: inline-block;
        font-weight: 400;
        line-height: 0.18rem;
    }

    .remark_edit_a_blue {
        margin-right: 0.3rem;
        margin-left: 0.3rem;
        color: #1F8DC5;
    }

    .remark_edit_a_gray {
        color: #ACACAC;
    }
    .remark_scan-note{
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color:#5A5A5A;
        top: 2.4rem;
        left: 50%;
        transform: translate(-50%, 0%);
        /* left: 0.7rem; */
        /* width: auto; */
        width: max-content;
        height:0.3rem;
        line-height: 0.3rem;
        background:#fff;
        box-shadow:-0.03rem 0.06rem 0.09rem rgba(0,0,0,0.16);
        opacity:1;
        border-radius:0.13rem;
        font-size: 0.15rem;
    }
    .remark_scan-icon{
        height: 50%;
    }
    .action-button{
        // position: fixed;
        position: sticky;
        bottom: 0.4rem;
        width: 100%;
    }
    .bottom{
        position: fixed;
        bottom: 0;
    }
    .success_container{
      height: 100vh;
      height: 100svh;
      height: 100dvh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Return/Success.vue